import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import BaseController from '../BaseController';

@Controller({ fragment: 'logout-inactivity', component: 'layout-logout-inactivity' })
class LogoutInactivityController extends BaseController {

  @OnClick({ target: 'button-return-login' })
  onClickButtonRetornarTela(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }
}

export default LogoutInactivityController;